import { IProductRelease } from "src/models";
import { createAction, createAsyncAction } from "typesafe-actions";

export const reset = createAction('RESET')<void>();
export const getProductReleases = createAsyncAction(
    "scan/GET_PRODUCT_RELEASE_REQUEST",
    "scan/GET_PRODUCT_RELEASE_SUCCESS",
    "scan/GET_PRODUCT_RELEASE_FAILURE"
)<{ productId: string; requireAuth?: boolean }, IProductRelease[], Error>();

export const updateProductReleaseChangeLog = createAsyncAction(
    "scan/UPDATE_PRODUCT_RELEASE_REQUEST",
    "scan/UPDATE_PRODUCT_RELEASE_SUCCESS",
    "scan/UPDATE_PRODUCT_RELEASE_FAILURE"
)<{ productId: string; releaseId: string; changeLog: string }, IProductRelease, Error>();